import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useParams, useNavigate } from 'react-router-dom';
import { practitionerService } from '../../services/practitionerService';
import ReferralFormTemplate from '../../components/ReferralFormTemplate';
import Icon from '../../components/AppIcon';

const PublicPractitionerReferral = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [practitionerData, setPractitionerData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  // Load practitioner data from Supabase
  useEffect(() => {
    const loadPractitionerData = async () => {
      try {
        setIsLoading(true);
        const data = await practitionerService?.getBySlug(slug);

        if (!data) {
          setNotFound(true);
          setIsLoading(false);
          return;
        }

        setPractitionerData(data);
        setIsLoading(false);
      } catch (err) {
        console.error('Error loading practitioner:', err);
        setNotFound(true);
        setIsLoading(false);
      }
    };

    if (slug) {
      loadPractitionerData();
    }
  }, [slug]);

  // Loading state
  if (isLoading) {
    return (
      <div className="min-h-screen bg-[#1A1A1E] flex items-center justify-center">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-900/20 via-[#1A1A1E] to-[#1A1A1E]" />
        <div className="text-center relative z-10">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-500 mx-auto mb-4"></div>
          <p className="text-gray-300 text-lg">Chargement du praticien...</p>
        </div>
      </div>
    );
  }

  // Not found state
  if (notFound || !practitionerData) {
    return (
      <>
        <Helmet>
          <title>Praticien non trouvé | EndoReferral</title>
        </Helmet>
        <div className="min-h-screen bg-[#1A1A1E] flex items-center justify-center p-4">
          <div className="absolute inset-0 bg-gradient-to-br from-blue-900/20 via-[#1A1A1E] to-[#1A1A1E]" />
          <div className="max-w-md w-full bg-white/5 backdrop-blur-sm rounded-2xl shadow-xl border border-white/10 p-8 text-center relative z-10">
            <div className="w-16 h-16 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <Icon name="AlertCircle" size={32} className="text-red-400" />
            </div>
            <h2 className="text-2xl font-bold text-white mb-2">Praticien non trouvé</h2>
            <p className="text-gray-400 mb-6">
              Le praticien que vous recherchez n'existe pas ou n'est plus actif.
            </p>
            <button
              onClick={() => navigate('/')}
              className="px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white rounded-lg transition-all font-medium shadow-xl"
            >
              Retour à l'accueil
            </button>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Helmet>
        <title>{`Formulaire d'Adressage - ${practitionerData?.practitionerTitle} ${practitionerData?.practitionerName} | EndoReferral`}</title>
        <meta name="description" content={`Adressez votre patient à ${practitionerData?.practitionerTitle} ${practitionerData?.practitionerName} pour un traitement endodontique spécialisé`} />
      </Helmet>
      <ReferralFormTemplate
        practitionerData={practitionerData}
        slug={slug}
        pageTitle={`Formulaire d'Adressage - ${practitionerData?.practitionerTitle} ${practitionerData?.practitionerName}`}
      />
    </>
  );
};

export default PublicPractitionerReferral;